'use client'


//page
import Nav from './Nav';

export default function Pitch() {

    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-32">
                        <div className="text-left">
                            <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                                Pitch
                            </h1>
                            <div className='mt-10 w-full'>
                                <p className='text-white text-[22px] leading-[2rem] font-medium'>
                                    Venez siéger à un procès fictif hors-norme, basé sur des faits réels, convoquant poète d’hier et militante de l’ère #MeToo

                                    <br /><br />Une scène de séduction classique ou l’esthétisation d’un viol ?<br/>
                                    <span className='text-[18px] font-normal'>

                                    <br />En 2017, la mise au programme du concours de l’agrégation de lettres d’un poème d’André Chénier, « L’Oaristys », a suscité de vives réactions d’associations féministes et une controverse médiatique.<br/>

                                    <br /> La scène de théâtre devient tribunal puis agora pour un procès fictif qui réunit des acteur·ices professionnel·les et des expert·es de la société civile : avocat·es, magistrat·es, juristes spécialistes des violences sexuelles et expertes littéraires qui ont participé à la controverse.

                                    <br /><br /> Dans ce dispositif expérimental qui agite des questions brûlantes autour de la culture du viol, du consentement, de la cancel culture et de la liberté d’expression, l’auteur du XVIIIe siècle revient d’entre les morts défendre la réputation de son œuvre et l’honneur de son nom, tandis qu’une jeune enseignante féministe se trouve accusée de diffamation pour le tweet <i>#cheniercultureduviol</i>. Pour trancher l’affaire, à l’issue de l’instruction, ce ne sont pas des juges professionnels mais des juré·es issu·es de l’assemblée des spectateur·ices qui délibèrent et rendent le verdict.
                                    </span>
                                    <br /><br />Avertissement : cette performance traite de la culture du viol et représente une scène de violence sexuelle
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
